import { styled } from '@mui/material/styles'
import {
  Box,
  TableContainer,
  TableCell,
  TableRow,
  tableCellClasses,
} from '@mui/material'

// Styled TableCell for consistent appearance
export const StyledTableCell = styled(TableCell)({
  fontFamily: 'Gabarito',
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#F7F8FA',
    color: '#505470',
    fontFamily: 'Gabarito',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: 'Gabarito',
  },
})

// Styled TableRow for consistent appearance
export const StyledTableRow = styled(TableRow)({
  '&:nth-of-type(even)': {
    backgroundColor: '#F7F8FA',
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
  fontFamily: 'Gabarito',
})

// Add new shared components
export const TableWrapper = styled(Box)({
  height: '80vh',
  display: 'flex',
  flexDirection: 'column',
})

export const TableContainerStyled = styled(TableContainer)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  padding: 16,
  overflow: 'hidden',
  boxShadow: 'none',
  minHeight: 0,
})

export const VirtualTableContainer = styled(Box)({
  flex: 1,
  overflow: 'auto',
  position: 'relative',
  scrollbarWidth: 'thin',
  scrollbarColor: '#888 #f1f1f1',
  '&::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: '#f1f1f1',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#888',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: '#555',
    },
  },
  scrollBehavior: 'smooth',
})

export const VirtualRow = styled(Box)({
  display: 'flex',
  width: '100%',
  padding: '8px 0',
  '&:nth-of-type(even)': {
    backgroundColor: '#F7F8FA',
  },
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
})

export const VirtualCell = styled(Box)<{ width: string }>(({ width }) => ({
  width,
  padding: '8px 16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '12px',
  flex: 'none',
}))
